import { apiFetch, readJson, type GetToken } from '@/lib/api/client'
import type { OwnerListing, UpdateListingInput } from '@/lib/types/listing'
import type { Me } from '@/lib/types/me'

export function getMe(getToken: GetToken): Promise<Me> {
  return apiFetch('/api/me', { getToken }).then((response) =>
    readJson<Me>(response),
  )
}

export interface PreferencesInput {
  digestOptIn: boolean
  digestCategories: string[]
}

/** PUT /api/me/preferences — replaces the digest preferences wholesale. */
export function updateMyPreferences(
  input: PreferencesInput,
  getToken: GetToken,
): Promise<Me> {
  return apiFetch('/api/me/preferences', {
    method: 'PUT',
    body: input,
    getToken,
  }).then((response) => readJson<Me>(response))
}

export function listMyListings(getToken: GetToken): Promise<OwnerListing[]> {
  return apiFetch('/api/me/listings', { getToken }).then((response) =>
    readJson<OwnerListing[]>(response),
  )
}

export function updateMyListing(
  id: string,
  input: UpdateListingInput,
  getToken: GetToken,
): Promise<OwnerListing> {
  return apiFetch(`/api/me/listings/${id}`, {
    method: 'PATCH',
    body: input,
    getToken,
  }).then((response) => readJson<OwnerListing>(response))
}

export function removeMyListing(
  id: string,
  getToken: GetToken,
): Promise<OwnerListing> {
  return apiFetch(`/api/me/listings/${id}`, {
    method: 'DELETE',
    getToken,
  }).then((response) => readJson<OwnerListing>(response))
}

export function restoreMyListing(
  id: string,
  getToken: GetToken,
): Promise<OwnerListing> {
  return apiFetch(`/api/me/listings/${id}/restore`, {
    method: 'POST',
    getToken,
  }).then((response) => readJson<OwnerListing>(response))
}
